<template>
  <v-container fluid class="docForm">
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Sale Return / Credit Note</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small text to="/credit-notes">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row class="subtitle-2 text--primary mb-2">
          <v-col cols="12" md="4">
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>Invoice#:</td>
                    <td>{{ Invoice && Invoice.DocNum}}</td>
                  </tr>
                  <tr>
                    <td>Client:</td>
                    <td>{{ Invoice.Customer && Invoice.Customer.Name}}</td>
                  </tr>
                  <tr>
                    <td>Total Bill:</td>
                    <td>{{ Invoice && Invoice.DocTotal | currency}}</td>
                  </tr>
                  <tr>
                    <td>Total Paid:</td>
                    <td>{{ Invoice && TotalPaid | currency}}</td>
                  </tr>
                  <tr>
                    <td>Balance:</td>
                    <td>{{ Invoice && Balance | currency}}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <v-col cols="12" offset-md="4" md="4">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Account</th>
                    <th class="text-left">Amount Paid</th>
                    <th class="text-left">Ref No</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in Payments" v-bind:key="index">
                    <td>{{ item.Account.Name }}</td>
                    <td>{{ item.Amount | currency}}</td>
                    <td>{{ item.PaymentRemarks }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-row class="subtitle-2 text--primary mt-1" style="background-color: #E2E3E6">
          <v-col cols="12" md="6">
            <v-row dense>
              <v-col cols="12">
                <span class="style-16">Sold Products</span>

                <v-btn text color="red" class="float-right" @click="cancelDialog = true">
                  <v-icon left>mdi-close</v-icon>Cancel Entire Invoice
                </v-btn>
              </v-col>

              <v-col cols="12">
                <v-data-table
                  class="px-2"
                  dense
                  light
                  @item-selected="onItemSelected"
                  :mobile-breakpoint="0"
                  :items-per-page="100"
                  :headers="headers"
                  :items="SaleRows"
                  item-key="id"
                  hide-default-footer
                  show-select
                  v-model="selectedRows"
                  :single-select="true"
                >
                  <template v-slot:item.Name="{ item }">
                    <span style="width: 200px">{{ item.product.Name }}</span>
                  </template>

                  <template v-slot:item.Quantity="{ item }">
                    {{
                    item.Quantity
                    }}
                  </template>

                  <template v-slot:item.Price="{ item }">
                    <span v-if="item.Price">{{ item.Price | currency }}</span>
                  </template>

                  <template v-slot:item.DiscSum="{ item }">
                    {{
                    item.DiscSum
                    }}
                  </template>

                  <template v-slot:item.LineTotal="{ item }">
                    {{
                    item.LineTotal | currency
                    }}
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" md="6">
            <v-row dense>
              <v-col cols="12">
                <span class="style-16">Returned Products</span>
                <v-btn text color="primary" class="float-right" @click="cleareReturnList">
                  <v-icon>mdi-close</v-icon>Clear Return List
                </v-btn>
              </v-col>
              <v-col cols="12">
                <v-data-table
                  class="px-2"
                  dense
                  light
                  :mobile-breakpoint="0"
                  :items-per-page="100"
                  :headers="returnHeaders"
                  :items="returnedRows"
                  item-key="id"
                  hide-default-footer
                >
                  <template v-slot:item.Name="{ item }">
                    <span style="width: 200px">{{ item.product && item.product.Name }}</span>
                  </template>

                  <template v-slot:item.RowQuantity="{ item }">
                    <v-text-field
                      style="width: 100px"
                      autocomplete="off"
                      type="number"
                      class="orderInput"
                      single-line
                      outlined
                      dense
                      v-model="item.RowQuantity"
                    ></v-text-field>
                  </template>

                  <template v-slot:item.RowPrice="{ item }">
                    <span>{{ item.RowPrice | currency }}</span>
                  </template>

                  <template v-slot:item.DiscSum="{ item }">
                    {{
                    item.DiscSum
                    }}
                  </template>

                  <template v-slot:item.RowLineTotal="{ item }">
                    {{
                    (item.RowQuantity * item.RowPrice) | currency
                    }}
                  </template>

                  <template v-slot:item.action="{ item }">
                    <v-btn icon @click="removeItem(item)">
                      <v-icon color="red">mdi-close</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>

            <div class="style-18 float-right mt-3">
              Total Returns:
              <span style="color: red">{{ totalReturns | currency }}</span>
            </div>
          </v-col>
        </v-row>

        <v-row class="mt-4">
          <v-col cols="12">
            <v-btn color="primary" class="float-right" small @click="save" :loading="loader">Return Sold Items</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- cancelling entire dialog -->
    <v-dialog v-model="cancelDialog" max-width="750px">
      <v-card>
        <v-toolbar dense color="secondary" flat>
          <v-toolbar-title>Cancel Entire Sale <v-icon color="red">mdi-alert-outline</v-icon></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="cancelDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <span class="style-16">Invoice#: {{ Invoice && Invoice.DocNum}}</span>
              </v-col>

              <v-col cols="12">
                <span class="style-16">Client: {{ Invoice.Customer && Invoice.Customer.Name}}</span>
              </v-col>

              <v-col cols="12">
                <span class="style-16">Total Bill: {{ Invoice && Invoice.DocTotal | currency}}</span>
              </v-col>

              <v-col cols="12">
                <span class="style-18" style="color: red">Are you sure you want to cancel the whole  sale ?</span>
              </v-col>

              <v-col cols="12">
                <v-btn color="accent" class="float-right" @click="cancelSale" :loading="cancelLoader">
                  <v-icon left>mdi-close</v-icon> Yes, Cancel
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of cancelling entire modal-->

    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  components: {},
  computed: {
    totalReturns() {
      return this.returnedRows.reduce(
        (acc, item) => acc + item.RowQuantity * item.RowPrice,
        0
      );
    }
  },
  data: () => ({
    selectAll: false,
    cancelDialog: false,
    CancelEntireInvoice: false,
    loader: false,
    cancelLoader: false,
    dataItem: {},
    Invoice: {},
    TotalPaid: 0,
    Balance: 0,
    returnedRows: [],
    selectedRows: [],
    Payments: [],
    headers: [
      { text: "Product", value: "Name" },
      { text: "Qty", value: "Quantity" },
      // { text: "Unit", value: "Unit" },
      { text: "Price", value: "Price" },
      { text: "Total", value: "LineTotal" }
    ],
    returnHeaders: [
      { text: "Product", value: "ProductName" },
      { text: "Qty", value: "RowQuantity" },
      // { text: "Unit", value: "Unit" },
      { text: "Price", value: "RowPrice" },
      { text: "Total", value: "RowLineTotal" },
      { text: "Action", value: "action", sortable: false }
    ],
    SaleRows: []
  }),
  watch: {
    "$route.params.id": {
      handler: "getById",
      immediate: true
    }
  },
  methods: {
    getById(val) {
      const self = this;
      // get record
      var url = `/sales-invoice/${val}`;
      this.$store
        .dispatch("get", url)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.Invoice = res.ResponseData.Invoice;
            self.TotalPaid = res.ResponseData.TotalPaid;
            self.Balance = res.ResponseData.Balance;
            self.Payments = res.ResponseData.Payments;
            self.SaleRows = res.ResponseData.SaleRows;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    cancelSale() {
      // cannot return more than the quantity sold
      var invoiceId = this.Invoice.id;
      var url = `/cancel-entire-sale/${invoiceId}`;

      const self = this;
      this.cancelLoader = true;
      this.$store
        .dispatch("get", url)
        .then(res => {
          if (res.ResultCode == 1200) {
            this.$refs.snackbar.show(res.ResultDesc, "green");
            self.cancelLoader = false;
            this.$router.push("/credit-notes");
          } else {
            self.cancelLoader = false;
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.cancelLoader = false;
          this.$refs.snackbar.show(err, "red");
        });
    },
    save() {
      if (this.returnedRows.length == 0) {
        this.$refs.snackbar.show("No items to return", "red");
        return;
      }

      // cannot return more than the quantity sold
      if (this.Invoice.DocTotal < this.totalReturns) {
        this.$refs.snackbar.show(
          "Total returns cannot be more than the total invoice",
          "red"
        );
        return;
      }

      var rows = [];
      for (const item of this.returnedRows) {
        var LineTotal =
          parseFloat(item.RowQuantity) * parseFloat(item.RowPrice);
        var row = {
          BaseLineId: parseInt(item.RowId),
          ProductName: item.ProductName,
          ProductId: parseInt(item.ProductId),
          Quantity: parseFloat(item.RowQuantity),
          Price: parseFloat(item.RowPrice),
          UomEntry: parseInt(item.UomEntry),
          LineTotal: LineTotal
        };
        
        rows.push(row);
      }

      var url = `/sale-invoice/return`;
      var data = {
        BaseEntry: this.Invoice.id,
        CardCode: this.Invoice.CardCode,
        StoreId: this.Invoice.storeId,
        Date: new Date().toISOString().substr(0, 10),
        DocTotal: this.totalReturns,
        rows: rows
      };

      const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            this.$refs.snackbar.show(res.ResultDesc, "green");
            self.loader = false;
            this.$router.push("/credit-notes");
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
        });
    },
    removeItem(item) {
      this.returnedRows = this.returnedRows.filter(
        row => row.RowId !== item.RowId
      );

      this.selectedRows = [];
    },
    onItemSelected(row) {
      if (row.value == true) {
        var rowData = row.item;

        var details = {
          RowId: rowData.id,
          ProductName: rowData.product.Name,
          ProductId: rowData.productId,
          RowQuantity: rowData.Quantity,
          RowPrice: rowData.Price,
          UomEntry: rowData.UomEntry
        };

        var initialArray = [];
        initialArray.push(details);

        for (var i = 0; i < this.returnedRows.length; i++) {
          if (this.returnedRows[i].RowId == rowData.id) {
            return;
          }
        }

        this.returnedRows = [...this.returnedRows, ...initialArray];
      }
    },
    cleareReturnList() {
      this.returnedRows = [];
      this.CancelEntireInvoice = false;
      this.selectedRows = [];
    },
    cancelAll() {
      // if cancel entire invoice is checked
      if (this.CancelEntireInvoice == true) {
        var items = this.SaleRows;
        // add all rows to the returnedRows
        for (var i = 0; i < items.length; i++) {
          var details = {
            RowId: items[i].id,
            ProductName: items[i].product.Name,
            ProductId: items[i].productId,
            RowQuantity: items[i].Quantity,
            RowPrice: items[i].Price,
            UomEntry: items[i].UomEntry
          };

          var initialArray = [];
          initialArray.push(details);

          for (var j = 0; j < this.returnedRows.length; j++) {
            if (this.returnedRows[j].RowId == items[i].id) {
              return;
            }
          }

          this.returnedRows = [...this.returnedRows, ...initialArray];
        }
      }
      // end

      // if cancel entire invoice is unchecked
      if (this.CancelEntireInvoice == false) {
        this.returnedRows = [];
      }
    }
  }
};
</script>